import React from 'react';
import { FormCheck } from 'react-bootstrap';
import ReactTable from 'react-table';
import { getEditCell } from '../utils';

export const RequestLineItems = (props: any) => {
  const [selectAll, setSelectAll] = React.useState(false);
  const [selection, setSelection] = React.useState(
    props.data.map((item) => {
      return { id: item.id, checked: false };
    })
  );

  React.useEffect(() => {
    props.handleChecks({ data: selection });
  }, [selection]);

  const deselectAll = () => {
    const newSelection = selection.map((item) => {
      return { ...item, checked: false };
    });
    setSelection(newSelection);
  };

  const selectAllFn = () => {
    const newSelection = selection.map((item) => {
      return { ...item, checked: true };
    });
    setSelection(newSelection);
  };

  const columns = [
    {
      Header: (
        <FormCheck
          name='selectAll'
          checked={selectAll}
          id='selectAll'
          onClick={(e) => {
            setSelectAll(!selectAll);
            e.currentTarget.checked === true ? selectAllFn() : deselectAll();
          }}
        />
      ),
      accessor: 'boxid',
      width: 30,
      filterable: false,
      resizable: false,
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <FormCheck
              checked={
                selection.filter((item) => {
                  return item.id === row.id;
                })[0].checked || selectAll
              }
              onChange={(e) => {
                let temp = selection.slice();
                let item = temp.find((i) => i.id === row.id);
                if (item) {
                  item.checked = !item.checked;
                  setSelection(temp);
                }
              }}
            />
          </div>
        );
      },
    },
    {
      Header: 'Request #',
      accessor: 'requestItemFYNumber',
      width: 100,
      Cell: getEditCell,
    },
    {
      Header: 'id',
      accessor: 'id',
      show: false,
    },
    {
      Header: 'Description 1',
      accessor: 'description1',
    },
    {
      Header: 'Description 2',
      accessor: 'description2',
    },
    {
      Header: 'Description 3',
      accessor: 'description3',
    },
    {
      Header: 'Serial #',
      accessor: 'serialNumber',
      // width: 100,
    },
    {
      Header: 'Barcode',
      accessor: 'barcode',
      // width: 100,
    },
    {
      Header: 'Date Barcoded',
      accessor: 'deliveryDate',
    },
    {
      Header: 'Original Purchaser',
      accessor: 'originalPurchaser',
      show: false,
    },
    {
      Header: 'Status',
      accessor: 'status',
    },
  ];

  return (
    <ReactTable
      resizable={true}
      pageSize={props.data.length}
      columns={columns}
      showPagination={false}
      sortable={false}
      className='-striped -highlight mb-5'
      data={props.data}
      // defaultSorted={[
      //   {
      //     id: "requestItemFYNumber",
      //     desc: false
      //   },
      //   {
      //     id: 'id',
      //     desc: false
      //   }
      // ]}
    />
  );
};
